import { AnyAction } from 'redux';
import { GlobalActions } from '@ps20-frontend/shop-integration-redux';
import { FamilienStand, Tarifbereich } from '@ps20/bff-models';
import {
  App,
  determineAssekuranztarifFromTarifbereich,
  PhVorbelegungdaten,
} from '@ps20-frontend/frontend-models';
import { PhActions } from '../phActions';

export interface Versicherungsnehmer {
  geburtsdatum: string;
  familienstand: FamilienStand;
  isAssekuranztarif: boolean;
  tarifbereich?: Tarifbereich;
}

export const versicherungsnehmerReducer = function (
  sectionState: Versicherungsnehmer = null,
  action: AnyAction,
): Versicherungsnehmer {
  switch (action.type) {
    case PhActions.FAMILIENSTAND_CHANGED: {
      return {
        ...sectionState,
        familienstand: action.payload.familienstand,
      };
    }
    case PhActions.GEBURTSDATUM_CHANGED: {
      return {
        ...sectionState,
        geburtsdatum: action.payload.geburtsdatum,
      };
    }
    case GlobalActions.VORBELEGUNG_FOR_BEIBEHALTUNG_REQUESTED: {
      const actionPayload: PhVorbelegungdaten = action.payload;
      if (actionPayload.forApp === App.PH) {
        let gebDatum = sectionState.geburtsdatum;
        if (actionPayload.geburtsdatumVn) {
          const dateSplitted = actionPayload.geburtsdatumVn.split('-');
          gebDatum = `${dateSplitted[2]}.${dateSplitted[1]}.${dateSplitted[0]}`;
        }
        return { ...sectionState, geburtsdatum: gebDatum };
      }
      return sectionState;
    }
    case GlobalActions.EINSTIEG_REQUEST_SUCCESSFUL: {
      if (action.payload.versicherungsnehmer?.geburtsdatum) {
        const dateSplitted = action.payload.versicherungsnehmer.geburtsdatum.split('-');
        const dateAsString = `${dateSplitted[2]}.${dateSplitted[1]}.${dateSplitted[0]}`;
        return {
          ...sectionState,
          geburtsdatum: dateAsString,
        };
      } else {
        return sectionState;
      }
    }
    case GlobalActions.UPDATE_ASSEKURANZTARIF_DATA_AFTER_VV_LOAD:
    case GlobalActions.UPDATE_ASSEKURANZTARIF_DATA: {
      return {
        ...sectionState,
        isAssekuranztarif: action.payload,
      };
    }
    case GlobalActions.TARIFBEREICH_CHANGED: {
      return {
        ...sectionState,
        tarifbereich: action.payload,
        isAssekuranztarif: determineAssekuranztarifFromTarifbereich(action.payload),
      };
    }
    default:
      return sectionState;
  }
};
